import {front} from 'app/api/CirrusApi';
import {NetworkContract} from 'app/components/entities/network';

export class NetworkApi {
  static async getInterfaces(deviceId: string): Promise<NetworkContract.Interface[]> {
    return front.devices(deviceId).network().get();
  }
}
